import React, { ButtonHTMLAttributes } from "react";
import * as styles from "./FormButton.module.css";

interface Props {
  id?: string;
  type?: "button" | "submit" | "reset";
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  invert?: boolean;
}

export const FormButton: React.FC<Props> = ({
  id,
  className,
  type = "button",
  onClick,
  invert = false,
  children,
}) => {
  let fullClassName = styles.formbutton;
  if (invert) {
    fullClassName += ` ${styles.invert}`;
  }
  if (className) {
    fullClassName += ` ${className}`;
  }

  return (
    <button id={id} type={type} className={fullClassName} onClick={onClick}>
      {children}
    </button>
  );
};
